export default __webpack_public_path__ + "static/media/ADOBE_GARAMOND_LT_REGULAR.6583f3bb.ttf";